import { io } from 'socket.io-client';

// Lazy singleton — the socket only connects once something actually needs
// live session Q&A, and is reused across every panel opened afterward.
// WebSocket-only transport (no HTTP long-polling) to match the server side;
// see server/realtime/socketServer.js for why.
let socket = null;

export function getSocket() {
  if (socket) return socket;

  socket = io(window.location.origin, {
    path: '/portal/socket.io',
    transports: ['websocket'],
    autoConnect: false,
    auth: (cb) => cb({ token: localStorage.getItem('faithinsight_token') }),
  });

  return socket;
}

export function connectSocket() {
  const s = getSocket();
  if (!s.connected) s.connect();
  return s;
}
